"use strict";
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
import store from "@/store";

const config = {
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://coracao.wikki.com.br"
      : "http://localhost:8000"
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    if (store.getters["auth/isAuthenticated"]) {
      config.headers["Authorization"] = `Bearer ${
        (store.state as any).auth.token
      }`;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

_axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status === 401) {
      store.dispatch("auth/logout");
    }
    return Promise.reject(error);
  }
);

Vue.use(VueAxios, _axios);

export default _axios;
